import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ListComponent } from "./list/list.component";
import { AddComponent } from "./add/add.component";
import { ViewComponent } from "./view/view.component";
import { NewReportComponent } from "./new-report/new-report.component";

const routes: Routes = [
  {
    path: "",
    children: [
      {
        path: "list",
        component: ListComponent,
        data: {
          title: "Assets List Page",
        },
      },

      {
        path: "keywords",
        component: NewReportComponent,
        data: {
          title: "Assets Reports",
        },
      },
      {
        path: "add",
        component: AddComponent,
        data: {
          title: "Add Assets Page",
        },
      },
      {
        path: "edit/:id",
        component: AddComponent,
        data: {
          title: "Edit Assets Page",
        },
      },
      {
        path: "view/:id",
        component: ViewComponent,
        data: {
          title: "View Assets Page",
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AssetsRoutingModule {}
